import { TripPlacesInput } from '../../lib/types/models/trip-places/trip-places-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripPlace(data: TripPlacesInput) {
  return restApiClient.url(constructApiUrl(API.tripPlaces.create.url, null)).post(data)
}
